var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@uigovpe/components";
import { useToast } from "../../hooks";
/**
 * Button that copies a value to clipboard and shows a toast notification.
 */
export var CopyButton = function (_a) {
    var value = _a.value, _b = _a.successMessage, successMessage = _b === void 0 ? "Copiado!" : _b, _c = _a.title, title = _c === void 0 ? "Copiar" : _c, _d = _a.className, className = _d === void 0 ? "" : _d;
    var toast = useToast();
    if (!value)
        return null;
    var handleCopy = function () {
        navigator.clipboard.writeText(value);
        toast.info(successMessage);
    };
    return (_jsx("button", __assign({ type: "button", onClick: handleCopy, title: title, className: "p-1 rounded hover:bg-gray-100 text-blue-500 hover:text-blue-600 transition-colors shrink-0 ".concat(className) }, { children: _jsx(Icon, { icon: "file_copy", outline: true, className: "text-sm" }) })));
};
